// 応募しない求人一覧
import axios from '@/plugins/axios';
import { endpoint } from '@/api/apiConstants';
import { TrnCareerRecommendUpdateForm } from '@/types';
import { CareerSettingForm, TrnCareerBasicInfoUpdateForm, TrnCareerResumeUpdateForm } from '@/types/career';


type CareerParam = {
  careerId: number;
};

type ZipCodeParam = {
  zipCode: string;
};

export const updateRecommend = async ( params: TrnCareerRecommendUpdateForm) => {
  const res = await axios.post(endpoint.updateRecommend, params);
  return res;
};

export const getCareerInfo = async () => {
    const res = await axios.post(endpoint.getCareerInfo, {});
    return res;
};

export const updateCareerSettingFlag = async (params: CareerSettingForm) => {
    const res = await axios.post(endpoint.updateSettingFlag, params);
    return res;
};

export const getCareerInfoForRecommend = async () => {
    const res = await axios.get(endpoint.getCareerInfoForRecommend);
    return res;
};

export const getCareerInfoForResume = async () => {
    const res = await axios.get(endpoint.getCareerInfoForResume);
    return res;
};

export const getCareerInfoForConditionSearch = async () => {
    const res = await axios.get(endpoint.getCareerInfoForConditionSearch);
    return res;
};

export const updateCareerInfoForResume = async (params: TrnCareerResumeUpdateForm) => {
  const res = await axios.post(endpoint.updateResume, params);
  return res;
};

export const updateCareerBasicInfo = async (params: TrnCareerBasicInfoUpdateForm) => {
  const res = await axios.post(endpoint.updateBasicInfo, params);
  return res;
};

export const selectZipCode = async (params: ZipCodeParam) => {
  const res = await axios.post(endpoint.selectZipCode, params);
  return res;
};

export const getMstUserInfo = async () => {
  const res = await axios.get(endpoint.getMstUserInfo);
  return res;
};